// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"602":"0567abc2","667":"0567abc2"}[chunkId] + ".chunk.css";
};